
import $ from 'jquery';
import logger from './logger';

import CSSCustomProperties from './CSSCustomProperties';
import ScrollDirection from './ScrollDirection';
import Header from './Header';
import Grid from './Grid';
import LazyLoader from './LazyLoader';
import BackToTop from './BackToTop';
import Pano from './Pano';
import Slideshow from './Slideshow';
import Dev from './Dev';

$(function () {
    var o = {
        devMode: false
    };

    if (o.devMode) {
        Dev({ devMode: o.devMode });

        logger('app started!', {
            enabled: o.devMode,
            prefix: 'index.js',
            prefixColor: 'yellow'
        });
    }

    CSSCustomProperties({ devMode: o.devMode });
    ScrollDirection({ devMode: o.devMode });
    Header({ devMode: o.devMode });
    Grid({ devMode: o.devMode });
    LazyLoader({ devMode: o.devMode });
    BackToTop({ devMode: o.devMode });
    Pano({ devMode: o.devMode });
    Slideshow({ devMode: o.devMode });
});
